import React, { Component } from 'react';
import Table from '@/components/EditableTable';
import {
  getSignalPinsData,
  getSignalTitleCheckBox,
  getSignalCheckBox,
  CHECK_BOX_ALL
} from '../../../../services/Andes_v2/channel';

const signalColumns = [
  {
    title: 'checkBox',
    dataIndex: 'check',
    key: 'check',
    width: 50
  }, {
    title: 'Differential Nets',
    dataIndex: 'nets',
    key: 'nets'
  }
];
class SignalNetsTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      signalColumns
    }
  }

  componentDidMount() {
    this.columnsCell();
  }

  componentDidUpdate(prevProps) {
    const { serdesType } = this.props;
    if (serdesType !== prevProps.serdesType) {
      this.columnsCell();
    }
  }

  columnsCell = () => {
    const { signalColumns } = this.state;
    const { serdesType } = this.props;
    signalColumns[0].title = () => {
      const { selectedSignals, signals } = this.props;
      return getSignalTitleCheckBox({
        selectedSignals,
        signals,
        checkSignals: this.checkSignals
      })
    }

    signalColumns[0].render = (_, record) => {
      return getSignalCheckBox({ record, checkSignals: this.checkSignals, serdesType })
    };

    signalColumns[1].render = (_, record) => {
      return {
        children: <span>{record.nets && record.nets.length ? record.nets.join(", ") : <span className='aurora-placeHolder'>{record.netPlaceHolder}</span>}</span>,
      }
    };
    this.setState({ signalColumns })
  }

  delSignal = (e, record) => {
    e.stopPropagation();
    let _signals = this.props.signals;
    _signals = _signals.filter(item => item.name !== record.signal);
    this.props.updateSignals(_signals)
  }

  checkSignals = (e, key, type) => {
    e && e.stopPropagation();
    const checked = e && e.target ? e.target.checked : false;
    let { selectedSignals, signals } = this.props;
    let _selectedSignals = [...selectedSignals];
    if (key === CHECK_BOX_ALL) {
      _selectedSignals = checked ? signals.map(item => item.name) : [];
    } else if (type === "group") {
      const groupSignals = signals.filter(item => item.group === key).map(it => it.name);
      if (checked) {
        _selectedSignals = [...new Set([..._selectedSignals, ...groupSignals])];
      } else {
        _selectedSignals = _selectedSignals.filter(item => !groupSignals.includes(item));
      }
    } else {
      if (checked) {
        _selectedSignals = [...new Set([..._selectedSignals, key])];
      } else {
        _selectedSignals = _selectedSignals.filter(item => item !== key);
      }
    }
    this.props.updateSelectedSignals(_selectedSignals);
  }

  render = () => {
    const { signals, selectedSignals, serdesType, loading } = this.props;
    const { signalColumns } = this.state;
    const dataList = getSignalPinsData([], signals, selectedSignals, serdesType);
    const data = dataList ? dataList.map((record, index) => ({ ...record, index })) : []
    return (
      <div className="create-channel-signals-table-content">
        <Table
          ref={(ref) => this.table = ref}
          rowKey={(record) => record.index}
          columns={signalColumns}
          size="small"
          dataSource={data}
          /*  scroll={{ y: 300 }} */
          className='andes-v2-table create-channel-signals-table channel-signals-pins-table space-10'
          loading={loading}
        />
      </div>
    );
  }
}
export default SignalNetsTable;